import { postDataWithParams } from 'src/consumer/services/profileService'

export async function attachMeditationsToTimer(timers, clientSessionId) {
  console.log({ timers })
  const resp1 = await postDataWithParams(
    '/api/secure/v2/add/user/meditations',
    {},
    {
      meditationIds: timers?.map((timer) => timer.id)?.join(','),
      anonymsSessionId: clientSessionId,
      clientSessionId,
    },
  )
  if (resp1.status === 200) {
    const responses = await Promise.all(
      timers.map((timer) =>
        postDataWithParams(`/api/secure/v2/add/meditation/${timer.id}/details`, {
          languageCode: 'en',
        }),
      ),
    )
    if (responses.every((response) => response.status === 200)) {
      return { status: 200, message: 'Successfully attached timers' }
    } else {
      return { status: 400, message: 'Failed to attach timers' }
    }
  } else {
    return { status: 400, message: 'Failed to attach timers' }
  }
}
